import React, { createContext, useCallback, useState } from 'react'

import { Modal } from 'antd'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { onError, onSuccess } from '../../utils/apiHelper'
import { getUser } from '../../reducers/UserReducer'
import { addInternshipRequestFile } from '../../utils/api/internshipRequest'
import InternshipRequestFileForm from '../../Components/shared/Forms/InternshipRequestFileForm'
import { ErrorMessages, HttpStatuses } from '../../utils/http'

export const InternshipRequestFileModalContext = createContext()

const DEFAULT_FILE = { data: null, callback: null }

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const InternshipRequestFileModal = ({ children, user, t }) => {
  const [selectedFile, setSelectedFile] = useState(DEFAULT_FILE)
  const [visible, setVisible] = useState(null)

  const handleSubmit = useCallback(({ data, file }, force = false) => {
    addInternshipRequestFile(user, selectedFile.data.individualInternshipRequest, { file, type: data.type, force}).then(json => {
      if (json?.data) {
        onSuccess(t('internship_request_file.create.success'))

        if (selectedFile.callback) {
          selectedFile.callback(json.data)
        }
      }
    }).catch(error => {
      if (error.code === HttpStatuses.CONFLICT && error.message === ErrorMessages.CONVENTION_ALREADY_EXISTS) {
        setVisible(() => () => handleSubmit({ data, file }, true))
      } else {
        onError(t('internship_request_file.create.error'))
      }
    }).finally(() => {
      setSelectedFile(DEFAULT_FILE)
    })
  }, [selectedFile, setSelectedFile, user, t])

  return (
    <>
      <InternshipRequestFileModalContext.Provider value={{ setSelectedFile }}>
        {children}
      </InternshipRequestFileModalContext.Provider>
      <Modal
        width={500}
        title={t('internship_request_file.title')}
        visible={!!selectedFile.data}
        onCancel={() => setSelectedFile(DEFAULT_FILE)}
        footer={null}
        destroyOnClose
      >
        <InternshipRequestFileForm
          item={selectedFile.data}
          onSubmit={handleSubmit}
        />
      </Modal>
      <Modal
        visible={!!visible}
        title={t('common.warning')}
        okText={t('internship_request_file_modal.duplicate.ok_button')}
        cancelText={t('internship_request_file_modal.duplicate.cancel_button')}
        okButtonProps={{ type: 'danger' }}
        onOk={() => {
          visible()
          setVisible(null)
        }}
        onCancel={() => setVisible(null)}
      >
        {t('internship_request_file_modal.duplicate.body')}
      </Modal>
    </>
  )
}

export default connect(mapStateToProps)(InternshipRequestFileModal)
